import { Nullable } from '../../types/common'
import { delay } from '../../utils/utils'
import BaseComponent from '../base-component/base-component'

class TabWithDynamicHeight extends BaseComponent {
  content: Nullable<HTMLElement>
  resizeObserver: ResizeObserver

  constructor() {
    super()

    this.content = this.querySelector('[data-tabs-element-content]')

    this.resizeObserver = new ResizeObserver(this.handleContentResize)

    if (this.content) {
      this.resizeObserver.observe(this.content)
    }
  }

  connectedCallback(): void {
    this.updateMaxHeight(this.isVisible)
  }

  disconnectedCallback(): void {
    this.resizeObserver.disconnect()
  }

  handleContentResize = (): void => {
    this.updateMaxHeight(this.isVisible)
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.updateMaxHeight(this.isVisible)
  }

  show(): Promise<void> {
    this.setVisible(true)

    return delay(0)
  }

  hide(): Promise<void> {
    this.setVisible(false)

    return delay(0)
  }

  setVisible(isVisible: boolean): void {
    this.setAttribute('aria-hidden', isVisible ? 'false' : 'true')
  }

  updateMaxHeight(isVisible: boolean): void {
    if (!this.content) {
      return
    }

    const height = isVisible ? this.content.offsetHeight : 0

    this.style.maxHeight = `${height}px`
  }

  get isVisible(): boolean {
    return this.getAttribute('aria-hidden') === 'false'
  }

  static get observedAttributes() {
    return ['aria-hidden']
  }
}

export default TabWithDynamicHeight
